import { render, staticRenderFns } from "./TextQuestion.vue?vue&type=template&id=0185558a"
import script from "./TextQuestion.vue?vue&type=script&lang=js"
export * from "./TextQuestion.vue?vue&type=script&lang=js"
import style0 from "./TextQuestion.vue?vue&type=style&index=0&id=0185558a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports